import { useEffect } from 'react';

const preventActionHandler = (e) => {
  const { target } = e;
  const isElementNode = target.nodeType === 1;
  const nodeName = target.nodeName.toLowerCase();
  const isInput = nodeName === 'input' || nodeName === 'textarea';
  const isEditable = isElementNode && (isInput || target.isContentEditable);

  if (!isEditable) {
    e.preventDefault();
  }
};

const useCopyPasteGuard = (hasPermissionToCopyPaste: boolean): void => {
  useEffect(() => {
    const { body } = window.document;
    if (hasPermissionToCopyPaste) {
      body.removeEventListener('copy', preventActionHandler);
      body.removeEventListener('selectstart', preventActionHandler);
    } else {
      body.addEventListener('copy', preventActionHandler);
      body.addEventListener('selectstart', preventActionHandler);
    }

    return () => {
      body.removeEventListener('copy', preventActionHandler);
      body.removeEventListener('selectstart', preventActionHandler);
    };
  }, [hasPermissionToCopyPaste]);
};

export default useCopyPasteGuard;
